import { Component, OnInit, Injector } from '@angular/core';
import { TableAbstractComponent } from 'src/app/common-page-components/classes/table-abstract-component';
import { MembersSearchFiltersService } from '../../services/members-search-filters.service';
import MemberAssociationsStore, { IMemberAssociations } from 'src/app/common-page-components/stores/entities-store/continental-associations-store';
import { HttpClient } from '@angular/common/http';
import { mergeMap, tap, map, combineLatest, filter } from 'rxjs/operators';
import { IHeaderConfig } from 'src/app/common-page-components/headers-component/headers-component.component';

/**
 * Show members in a table with filters.
 *
 * @export
 * @class TableMembersSearchComponent
 * @extends {TableAbstractComponent}
 * @implements {OnInit}
 */
@Component({
  selector: 'app-table-members-search',
  templateUrl: './table-members-search.component.html',
  styleUrls: ['./table-members-search.component.scss']
})
export class TableMembersSearchComponent extends TableAbstractComponent implements OnInit {
  headers: Array<IHeaderConfig> = [
    { name: 'Name', isSortable: true, sortProperty: 'Name' },
    { name: "Country", isSortable: true, sortProperty: 'Country' },
    { name: 'Continent', isSortable: true, sortProperty: 'CA' },
    { name: '', isSortable: false, }
  ]

  /**
   * Creates an instance of TableMembersSearchComponent.
   *
   * @param {Injector} injector
   * @param {HttpClient} http
   * @param {MembersSearchFiltersService} filters_service
   *   Search filters.
   *
   * @memberof TableMembersSearchComponent
   */
  constructor(injector: Injector, http: HttpClient, public filters_service: MembersSearchFiltersService) {
    super(injector, filters_service, new MemberAssociationsStore(http));
    this.filter_service.sortLocator.sortingType = 'Country' as any;
    this.filter_service.sortLocator.asc = true;
  }

  /**
   * Implements ngOnInit().
   *
   * @memberof TableMembersSearchComponent
   */
  ngOnInit(): void {
    this.filters_service.getDataStreamWithFilters().pipe(
      combineLatest([this.reload.asObservable()]), map(([a, b]) => a), map(([order, text, region]) => {
        const params = {
          Continent: region ? region.CaId : undefined,
          fText: text.text,
          SortBy: order.sortingSend
        }
        return params;
      }), mergeMap(params => this.model.requestData(params, this.request_more_data)
      )).subscribe();

  }


  /**
   * Generate a route for a federation.
   *
   * @param {IMemberAssociations} federation
   *   Federation.
   *
   * @returns string
   *   Path to federation.
   * @memberof TableMembersSearchComponent
   */
  generateRoute(federation: IMemberAssociations) {
    return `/members/detail/${federation.NOC}/${federation.MaName.toLocaleLowerCase().replace(new RegExp(' ', 'g'), '-')}`
  }

  /**
   * Helper function for replace the name of url for navigation and avoid spaces
   *
   * @param {string} name
   * @returns
   * @memberof BootstrapMembersSearchComponent
   */
  changeNameForURL(name:string){
    return name.toLowerCase().replace(/ /g, '-');
  }
}
